import { colorPalette } from '@shared/config/colorsConfig';

export const CHAT_SKELETON = {
    delayMs: 250,
    loadTimeoutMs: 30000,
    sweepMs: 1400,
    listRows: 3,
    dimmedRowOpacity: 0.6,
    loadingMoreHeight: 48,
    textBar: { height: 12, borderRadius: 6 },
    dot: { stepMs: 200, onMs: 300, offMs: 600, minOpacity: 0.25 },
    colors: {
        neutral: { base: colorPalette.gray[200], band: colorPalette.gray[300] },
        tint: { base: colorPalette.secondary[100], band: colorPalette.secondary[300] },
    },
} as const;

export const CHAT_SKELETON_KEY = {
    list: 'list',
    thread: 'thread',
} as const;

export const CHAT_SKELETON_BUBBLES = [
    { mine: false, width: '58%', height: 44 },
    { mine: true, width: '44%', height: 36 },
    { mine: false, width: '70%', height: 56 },
] as const;
